<template>
  <div 
    v-if="notification.show"
    class="sm-notification"
    :class="notification.type"
  >
    <div class="sm-wrap">
      <div class="sm-notification__content">
        <div>
          <h4 v-if="notification.title.length">{{notification.title}}</h4>
          <p 
            v-if="notification.text && notification.text.length"
            v-html="notification.text"
          ></p>
        </div>
      </div>
      <a 
        href="#"
        class="sm-notification__close"
        @click.prevent="close()"
      ></a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'notification-elem',
  data() {
    return {
      notification: {
        show: false,
        type: 'notification',
        title: '',
        text: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      globalNotification: 'globalNotification'
    })
  },
  methods: {
    close() {
      this.notification.show = false;
      //this.$emit('close');
    }
  },
  watch: {
    globalNotification(val) {
      this.notification = {
        show: true,
        type: val.type,
        title: val.value[0],
        text: val.value[1] ? val.value[1].replace(new RegExp('\n', 'g'), '<br />') : ''
      }

      window.scrollTo(0, 0);
    },
    $route(to, from) {
      this.notification.show = false;
    }
  }
}
</script>
